import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { DropDownModel } from 'app/modules/common/entities/DropDownModel';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { SharedService } from 'app/modules/common/services/shared-service';
import { DoctorVisitSaveModel } from 'app/modules/coordinator/entities/doctor-visit';
import { CoordinatorDoctorService } from 'app/modules/coordinator/services/coordinator-doctor.service';
import { TaskSaveService } from 'app/modules/task/services/task-save.service';
import { Moment } from 'moment';

@Component({
    selector: 'app-add-edit-doctor-visit',
    templateUrl: './add-edit-doctor-visit.component.html',
    styleUrls: ['./add-edit-doctor-visit.component.scss'],
    standalone: false
})
export class AddEditDoctorVisitComponent implements OnInit {

  public isEdit = false;
  public title = '';
  public doctorVisitForm: UntypedFormGroup;
  public saveModel: DoctorVisitSaveModel = new DoctorVisitSaveModel();
  public coordinatorList$: Array<DropDownModel>;

  public defaultCoordinator = '';

  constructor(
    private taskService: TaskSaveService,
    private dialogRef: MatDialogRef<AddEditDoctorVisitComponent>,
    private formBuilder: UntypedFormBuilder,
    private sharedService: SharedService,
    private coordinatorDoctorService: CoordinatorDoctorService) { }

  ngOnInit(): void {
    this.title = this.isEdit ? 'Editar la visita al médico' : 'Agregar visita al médico';
    this.initForm();
    this.initCoordinatorDropdown();
  }

  private initForm(): void {
    this.doctorVisitForm = this.formBuilder.group({
      Id: [this.saveModel.Id],
      Assistant: [this.saveModel.Assistant],
      Coordinator: [this.saveModel.Coordinator, Validators.required],
      Date: [this.saveModel.Date, Validators.required],
      Comments: [this.saveModel.Comments, Validators.maxLength(500)],
      DoctorId: [this.saveModel.DoctorId, Validators.required]
    });
  }

  private initCoordinatorDropdown(): void {
    this.taskService.GetActiveCoordinator().subscribe(res => {
      if (res) {
        this.coordinatorList$ = res.result;
      }
    });
  }

  public cancel(isSaved = false): void {
    this.dialogRef.close(isSaved);
  }

  public saveDoctorVisit(): void {
    this.doctorVisitForm.markAllAsTouched();
    if (this.doctorVisitForm.valid) {
      this.mapFormtoSaveModel();
      this.coordinatorDoctorService.AddEditDoctorVisit(this.saveModel).subscribe(res => {
        if(res.code === 0 && res.result) {
          this.sharedService.ShowSnackBar('Guardó los datos de la visita con éxito.');
          this.cancel(true);
        } else {
          this.sharedService.ShowSnackBar('No se pudieron guardar los datos de la visita.');
        }
      }, error => {
        console.error(error);
        this.sharedService.ShowSnackBar('Ha ocurrido un error. Por favor intente de nuevo.');
      });
    } else {
      this.sharedService.ShowSnackBar('Ingrese datos válidos para continuar.');
    }
  }

  private mapFormtoSaveModel(): void {
    this.saveModel = this.doctorVisitForm.value;
    let date: Moment = this.doctorVisitForm.get('Date').value;
    this.saveModel.Date = typeof date === 'string' ? date : DateHelper.getUTCDateString(DateHelper.getNativeDate(date));
  }

}
